var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"muted"},[_vm._v(_vm._s(_vm.$t('common.loading')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }